/**
 * Created by slava on 4/14/17.
 */

const SyncAdapters = {
    header: {
        getInfo: () => ({
            appversion: cleverapps.dataVersion.appVersion,
            dataversion: cleverapps.dataVersion.dataVersion
        })
    },

    dataversion: {
        order: -10000,

        beforeUpdate: (snapshot) => {
            cleverapps.dataVersion.onSync(snapshot);
        },

        getInfo: () => cleverapps.dataVersion.getInfo()
    },

    users: {
        getInfo: () => cleverapps.user.getInfo(),

        updateInfo: (serverData) => {
            cleverapps.user.updateInfo(serverData);

            if (cleverapps.playButton) {
                cleverapps.playButton.update();
            }
        }
    },

    userdelete: {
        getInfo: () => cleverapps.userDelete.getInfo(),

        updateInfo: (serverData) => cleverapps.userDelete.updateInfo(serverData)
    },

    settings: {
        getInfo: () => cleverapps.settings.getSaveInfo(),

        updateInfo: (serverData) => cleverapps.settings.updateInfo(serverData)
    },

    serverflags: {
        getInfo: () => cleverapps.serverFlags.getInfo(),

        updateInfo: (serverData) => cleverapps.serverFlags.updateInfo(serverData, true)
    },

    syncedStorage: {
        getInfo: () => cleverapps.syncedStorage.getInfo(),

        updateInfo: (serverData) => cleverapps.syncedStorage.updateInfo(serverData)
    },

    metha: {
        getInfo: () => cleverapps.meta.getInfo(),

        updateInfo: (serverData) => cleverapps.meta.updateInfo(serverData)
    },

    tournament: {
        getInfo: () => {
            if (typeof Game === "undefined" || !Game.currentGame || !Game.currentGame.competition || !Game.currentGame.competition.options || Game.currentGame.competition.options.type !== "tournament") {
                return;
            }
            const results = Game.currentGame.competition.results.filter((result) => !result.player);

            return {
                level: Game.currentGame.competition.options.level.getHumanReadableNumber(),
                results
            };
        },

        updateInfo: (serverData) => {
            if (serverData && serverData.level && serverData.results) {
                cleverapps.dataLoader.save(`${DataLoader.TYPES.COMPETITION}_tournament`, serverData);
            }
        }
    },

    bonuses: {
        getInfo: () => {
            if (!cleverapps.miniGame) {
                return;
            }
            return {
                event: cleverapps.miniGame.when
            };
        },

        updateInfo: (serverData) => {
            if (!cleverapps.miniGame) {
                return;
            }

            const bonus = cleverapps.miniGame;

            if (serverData.event < bonus.when || serverData.event > (Date.now() + bonus.interval)) {
                return;
            }

            bonus.locked = true;
            bonus.setWhenUnlock(serverData.event);
            bonus.save(false);
            bonus.changeLockedListener();
        }
    },

    tempgoods: {
        getInfo: () => {
            if (!cleverapps.unlimitedLives) {
                return;
            }
            return cleverapps.unlimitedLives.getInfo();
        },

        updateInfo: (serverData) => {
            if (!cleverapps.unlimitedLives) {
                return;
            }

            cleverapps.unlimitedLives.updateInfo(serverData, true);
        }
    },

    boosters: {
        getInfo: () => {
            if (!cleverapps.boosters) {
                return;
            }
            return cleverapps.boosters.data;
        },

        updateInfo: (serverData) => {
            if (!cleverapps.boosters) {
                return;
            }

            cleverapps.boosters.data = serverData;
            cleverapps.boosters.save(false);

            cleverapps.boosters.addInitAmount();
        }
    },

    starchests: {
        getInfo: () => {
            if (!cleverapps.starChest) {
                return;
            }
            return {
                stars: cleverapps.starChest.stars
            };
        },

        updateInfo: (serverData) => {
            if (!cleverapps.starChest) {
                return;
            }

            cleverapps.starChest.updateInfo(serverData, true);
        }
    },

    missions: {
        getInfo: () => cleverapps.missionManager.getInfo(),

        updateInfo: (serverData) => cleverapps.missionManager.updateInfo(serverData, true)

    },

    offers: {
        getInfo: () => cleverapps.offerManager.getInfo(),

        updateInfo: (serverData) => cleverapps.offerManager.updateInfo(serverData, true)

    },

    heroes: {
        getInfo: () => {
            if (typeof match3 === "undefined" || !match3 || !match3.heroes) {
                return;
            }
            return match3.heroes.getInfo();
        },

        updateInfo: (serverData) => {
            if (typeof match3 === "undefined" || !match3 || !match3.heroes) {
                return;
            }

            match3.heroes.updateInfo(serverData, true);
        }
    },

    subscription: {
        getInfo: () => cleverapps.subscription.getInfo(true),

        updateInfo: (serverData) => cleverapps.subscription.updateInfo(serverData, true)
    },

    forces: {
        getInfo: () => cleverapps.forces.getInfo(),

        updateInfo: (serverData) => cleverapps.forces.updateInfo(serverData, true)

    },

    cookiejar: {
        getInfo: () => {
            if (!levels || !levels.cookieJar) {
                return;
            }
            return levels.cookieJar.getCounterValue();
        },

        updateInfo: (serverData) => {
            const countOfCookies = serverData && serverData.counterValue !== undefined ? serverData.counterValue : serverData || 0;
            cleverapps.dataLoader.save(DataLoader.TYPES.COOKIE_JAR, countOfCookies);

            if (levels && levels.cookieJar) {
                levels.cookieJar.load();
            }
        }
    },

    competitionstatistics: {
        getInfo: () => cleverapps.competitionStatistics.getInfo(),

        updateInfo: (serverData) => cleverapps.competitionStatistics.updateInfo(serverData, true)
        
    },

    unitsshop: {
        getInfo: () => {
            if (!cleverapps.unitsShop) {
                return;
            }
            return cleverapps.unitsShop.getInfo();
        },

        updateInfo: (serverData) => {
            cleverapps.unitsShop && cleverapps.unitsShop.updateInfo(serverData);
        }
    },

    paymentshistory: {
        getInfo: () => cleverapps.paymentsHistory.getInfo(),

        updateInfo: (serverData) => {
            cleverapps.paymentsHistory.updateInfo(serverData);
        }
    },

    payments: {
        getInfo: () => connector.payments.getInfo(),

        updateInfo: (serverData) => {
            connector.payments.updateInfo(serverData);
        }
    },

    army: {
        getInfo: () => {
            if (!cleverapps.army) {
                return;
            }

            return cleverapps.army.getInfo();
        },

        updateInfo: (serverData) => {
            if (!cleverapps.army) {
                return;
            }

            return cleverapps.army.updateInfo(serverData);
        }
    },

    armylibrary: {
        getInfo: () => {
            if (!cleverapps.armyLibrary) {
                return;
            }

            return cleverapps.armyLibrary.getInfo();
        },

        updateInfo: (serverData) => {
            if (!cleverapps.armyLibrary) {
                return;
            }

            return cleverapps.armyLibrary.updateInfo(serverData);
        }
    },

    achievements: {
        getInfo: () => {
            if (!cleverapps.achievements) {
                return;
            }
            return cleverapps.achievements.getInfo();
        },

        updateInfo: (serverData) => {
            if (!cleverapps.achievements) {
                return;
            }
            cleverapps.achievements.load(serverData);
            cleverapps.achievements.save(false);
        }
    },

    stickersbook: {
        getInfo: () => {
            if (!cleverapps.stickersBook) {
                return;
            }
            return cleverapps.stickersBook.getInfo();
        },

        updateInfo: (serverData) => {
            if (!cleverapps.stickersBook) {
                return;
            }
            cleverapps.stickersBook.updateInfo(serverData);
        }
    },

    stickersbook2: {
        getInfo: () => {
            if (!cleverapps.stickersBook2) {
                return;
            }
            return cleverapps.stickersBook2.getInfo();
        },

        updateInfo: (serverData) => {
            if (!cleverapps.stickersBook2) {
                return;
            }
            cleverapps.stickersBook2.updateInfo(serverData);
        }
    },

    applyLoadedProgress: {
        beforeUpdate: () => {
            cleverapps.meta.stopLocation();
        },

        afterUpdate: () => {
            cleverapps.meta.switchLocation(cleverapps.meta.getMainLocationId());

            GameDataSaver.Reset();

            cleverapps.user.sendLetsPlayPush();
            connector.notifications.cancelAll();

            cleverapps.abExperiments.updateGroups();

            if (cleverapps.rewardedPromo) {
                cleverapps.rewardedPromo.load();
            }

            if (cleverapps.rewardedPromoTracker) {
                cleverapps.rewardedPromoTracker.load();
            }
        }
    },

    registerBySlots: function (name, adapter) {
        Meta.SLOTS.forEach((slotId) => {
            SyncAdapters[name + slotId] = {
                beforeUpdate: (snapshot) => adapter.beforeUpdate && adapter.beforeUpdate(slotId, snapshot),

                getInfo: () => adapter.getInfo(slotId),

                updateInfo: (serverData) => adapter.updateInfo(slotId, serverData),

                order: adapter.order
            };
        });
    }
};
